<template>
  <div class="row">
    <div class="col-12">
      <div
        class="navbar-light border-bottom border-white"
        :class="{ 'bg-light': $window.CONTEXT === 'production', 'bg-info': $window.CONTEXT === 'stage' }"
      >
        <div class="container-fluid">
          <div class="row">
            <div class="col-4 col-md-8">
              <nav ref="navRef" class="d-print-none navbar navbar-expand-lg">
                <button
                  ref="togglerRef"
                  class="navbar-toggler"
                  :class="{ collapsed: !menuOpen }"
                  type="button"
                  aria-controls="navbarSupportedContent"
                  :aria-expanded="menuOpen"
                  aria-label="Meni"
                  @click="menuOpen = !menuOpen"
                >
                  <span class="navbar-toggler-icon"></span>
                </button>
                <div
                  id="navbarSupportedContent"
                  class="navbar-collapse"
                  :class="{ show: menuOpen }"
                  :inert="!menuOpen && !isDesktop"
                  @click="onMenuClick"
                >
                  <ul class="navbar-nav me-auto mb-2 mb-lg-0" v-if="isAuthenticated">
                    <li class="nav-item">
                      <router-link :to="{ name: 'Home' }" class="nav-link" active-class="active">Domov</router-link>
                    </li>
                    <li
                      class="nav-item"
                      v-if="$hasRoleStartsWith(role, ['Admin', 'Leader', 'Worker']) && !$hasRole(role, ['WorkerService'])"
                    >
                      <router-link :to="{ name: 'Calls' }" class="nav-link" active-class="active">Klici</router-link>
                    </li>
                    <li class="nav-item" v-if="$hasRoleStartsWith(role, ['Admin', 'Leader', 'Worker', 'Customer'])">
                      <router-link :to="{ name: 'Service' }" class="nav-link" active-class="active"
                        >Servisni</router-link
                      >
                    </li>

                    <li class="nav-item" v-if="$hasRoleStartsWith(role, ['Admin', 'Leader', 'Worker', 'Customer'])">
                      <router-link :to="{ name: 'ServiceOrdersMap' }" class="nav-link" active-class="active"
                        >🚩</router-link
                      >
                    </li>
                    <li class="nav-item" v-if="$hasRoleStartsWith(role, ['Admin', 'LeaderService'])">
                      <router-link :to="{ name: 'Calendar' }" class="nav-link" active-class="active">📅</router-link>
                    </li>
                    <li class="nav-item" v-if="$hasRoleStartsWith(role, ['Admin', 'Leader'])">
                      <router-link :to="{ name: 'Absences' }" class="nav-link" active-class="active">Delo</router-link>
                    </li>

                    <li
                      class="nav-item"
                      v-if="
                        $hasRole(role, ['Administrator']) ||
                        $hasRoleEndsWith(role, ['Projects']) ||
                        $hasRoleStartsWith(role, ['Leader'])
                      "
                    >
                      <router-link :to="{ name: 'Projects' }" class="nav-link" active-class="active"
                        >Projekti</router-link
                      >
                    </li>
                    <li
                      class="nav-item"
                      v-if="
                        $hasRole(role, ['Administrator', 'WarehouseManager']) ||
                        $hasRoleEndsWith(role, ['Production']) ||
                        $hasRoleStartsWith(role, ['Leader'])
                      "
                    >
                      <router-link :to="{ name: 'Production' }" class="nav-link" active-class="active"
                        >Proizvodni</router-link
                      >
                    </li>
                    <li
                      class="nav-item"
                      v-if="$hasRole(role, ['Administrator']) || $hasRoleStartsWith(role, ['Leader'])"
                    >
                      <router-link :to="{ name: 'Offers' }" class="nav-link" active-class="active">Ponudbe</router-link>
                    </li>
                    <li class="nav-item" v-if="$hasRoleStartsWith(role, ['Admin', 'Leader', 'Worker', 'Warehouse'])">
                      <router-link :to="{ name: 'WarehouseTransfers' }" class="nav-link" active-class="active">
                        {{ worker.activeWarehouse.value?.name || "Medskladiščnice" }}
                      </router-link>
                    </li>
                    <li class="nav-item dropdown" v-if="!$hasRole(role, ['WorkerSubcontractor', 'Customer'])">
                      <a
                        class="nav-link dropdown-toggle"
                        href="#"
                        id="navbarDropdownMenuLink"
                        role="button"
                        data-bs-toggle="dropdown"
                      >
                        Šifranti
                      </a>
                      <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                        <li>
                          <router-link
                            :to="{ name: 'Workers' }"
                            class="dropdown-item"
                            active-class="active"
                            v-if="$hasRoleStartsWith(role, ['Admin', 'Leader', 'Worker'])"
                            >Delavci</router-link
                          >
                        </li>
                        <li>
                          <router-link
                            :to="{ name: 'Customers' }"
                            class="dropdown-item"
                            active-class="active"
                            v-if="$hasRole(role, ['Administrator'])"
                            >Stranke</router-link
                          >
                        </li>
                        <li>
                          <router-link
                            :to="{ name: 'Users' }"
                            class="dropdown-item"
                            active-class="active"
                            v-if="$hasRole(role, ['Administrator'])"
                            >Uporabniki</router-link
                          >
                        </li>
                        <li>
                          <router-link
                            :to="{ name: 'Warehouses' }"
                            class="dropdown-item"
                            active-class="active"
                            v-if="$hasRoleStartsWith(role, ['Admin', 'Leader'])"
                            >Skladišča</router-link
                          >
                        </li>
                        <li>
                          <router-link
                            :to="{ name: 'Facilities' }"
                            class="dropdown-item"
                            active-class="active"
                            v-if="$hasRoleStartsWith(role, ['Admin', 'Leader', 'Worker'])"
                            >Objekti</router-link
                          >
                        </li>
                        <li>
                          <router-link
                            :to="{ name: 'Devices' }"
                            class="dropdown-item"
                            active-class="active"
                            v-if="$hasRoleStartsWith(role, ['Admin', 'Leader', 'Worker'])"
                            >Naprave</router-link
                          >
                        </li>
                        <li>
                          <router-link
                            :to="{ name: 'Materials' }"
                            class="dropdown-item"
                            active-class="active"
                            v-if="$hasRoleStartsWith(role, ['Admin', 'Leader', 'Worker'])"
                            >Material</router-link
                          >
                        </li>
                        <li>
                          <router-link
                            :to="{ name: 'BomTemplates' }"
                            class="dropdown-item"
                            active-class="active"
                            v-if="$hasRoleStartsWith(role, ['Admin', 'Leader'])"
                            >BOM predloge</router-link
                          >
                        </li>
                        <li>
                          <router-link
                            :to="{ name: 'Commissions' }"
                            class="dropdown-item"
                            active-class="active"
                            v-if="$hasRoleStartsWith(role, ['Admin', 'Leader'])"
                            >Komisioni</router-link
                          >
                        </li>
                        <li>
                          <router-link
                            :to="{ name: 'ServiceOrdersWithCompletedMovementsCard' }"
                            class="dropdown-item"
                            active-class="active"
                            v-if="$hasRoleStartsWith(role, ['Admin', 'Leader'])"
                            >Premiki materiala</router-link
                          >
                        </li>
                      </ul>
                    </li>
                    <li class="nav-item" v-if="$hasRole(role, ['Customer'])">
                      <router-link :to="{ name: 'Facilities' }" class="nav-link" active-class="active"
                        >Objekti</router-link
                      >
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
            <div class="col-8 col-md-4">
              <div class="d-flex justify-content-end align-items-center mt-2">
                <button
                  v-if="$hasRoleStartsWith(role, ['Admin', 'Leader', 'Worker', 'Warehouse'])"
                  class="btn btn-sm btn-info me-2"
                  type="button"
                  @click="$router.push({ name: 'InternalOrder', params: { workOrderId: 'new' } })"
                >
                  Int.nalog
                </button>
                <Pause v-if="isAuthenticated" class="me-2" />
                <span class="navbar-text d-none d-xl-inline" v-show="!!user?.name">{{ user?.name }}</span>
                <SignInOutButton />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Notification />
  <Confirm />
  <ModalAssignWorkOrder
    :visible="!!assignTarget"
    :orderForAssignment="assignTarget"
    @close="closeAssign"
    @assigned="finishAssign"
  />
  <div v-if="!state.errors.value.length && !worker.workPauseStartDateTime.value" class="mt-2">
    <div v-if="currentCustomerId">
      <router-view />
    </div>
    <div v-else-if="worker.isLoaded.value && currentWorkerId">
      <router-view />
    </div>
    <div v-else class="p-5 mb-4 bg-light rounded-3">
      <div class="container-fluid py-5" v-show="!state.loading.value">
        <h1 class="display-5 fw-bold">Niste prijavljeni</h1>
        <p class="col-md-8 fs-4">Prosim prijavite se s klikom na gumb desno zgoraj.</p>
      </div>
    </div>
  </div>

  <pre v-show="false">
  {{ authState }}
  </pre>
</template>

<script setup>
import { computed, provide, ref, watch, onMounted, onUnmounted, watchEffect } from "vue"
import { useRoute } from "vue-router"

import {
  useAuth,
  authState,
  isAuthenticated,
  user,
  role,
  currentWorkerId,
  currentCustomerId,
} from "./composition-api/useAuth"
import { useWorker } from "./composition-api/useWorker"
import SignInOutButton from "./components/SignInOutButton.vue"
import Notification from "./components/Notification.vue"
import Confirm from "./components/Confirm.vue"
import { setError, setWarning, startLoading, stopLoading, useNotification } from "./components/Notification"
import ModalAssignWorkOrder from "./components/ModalAssignWorkOrder.vue"
import { assignTarget, closeAssign, finishAssign } from "./components/AssignWorkOrder"
import Pause from "./components/Pause.vue"

defineOptions({ name: "App" })

const { worker } = useWorker()
const { state } = useNotification()

// routes with meta.fullWidth (wide grids) drop the fixed-width container of #app (index.html)
const route = useRoute()
watchEffect(() => {
  const app = document.getElementById("app")
  app?.classList.toggle("container", !route.meta.fullWidth)
  app?.classList.toggle("container-fluid", !!route.meta.fullWidth)
})

// burger menu (below lg): closes on navigation, a tap outside, Escape, and when the viewport grows to lg
const navRef = ref(null)
const togglerRef = ref(null)
const menuOpen = ref(false)
const desktopQuery = window.matchMedia("(min-width: 992px)")
const isDesktop = ref(desktopQuery.matches)

const closeMenu = () => (menuOpen.value = false)
// the Šifranti dropdown toggle is a link too, but it only opens the submenu
const onMenuClick = (e) => {
  if (e.target.closest("a:not(.dropdown-toggle)")) closeMenu()
}
const onDocumentClick = (e) => {
  if (menuOpen.value && !navRef.value?.contains(e.target)) closeMenu()
}
const onDocumentKeydown = (e) => {
  if (e.key !== "Escape" || !menuOpen.value) return
  // an open Šifranti submenu takes the first Escape (Bootstrap closes it)
  if (navRef.value?.querySelector(".dropdown-menu.show")) return
  closeMenu()
  togglerRef.value?.focus()
}
const onDesktopChange = (e) => {
  isDesktop.value = e.matches
  closeMenu()
}

watch(() => route.fullPath, closeMenu)
onMounted(() => {
  document.addEventListener("click", onDocumentClick)
  document.addEventListener("keydown", onDocumentKeydown)
  desktopQuery.addEventListener("change", onDesktopChange)
})
onUnmounted(() => {
  document.removeEventListener("click", onDocumentClick)
  document.removeEventListener("keydown", onDocumentKeydown)
  desktopQuery.removeEventListener("change", onDesktopChange)
})

// the GPS fix can take seconds on a phone; the loading overlay keeps e.g. "start travel" from being tapped twice meanwhile
const getLocationAsync = (options = {}) => {
  startLoading("getLocationAsync")
  return new Promise((resolve, reject) => {
    if ((!"geolocation") in window.navigator) {
      console.error("no browser support for geolocation")
      reject("no browser support")
    } else {
      window.navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            altitude: position.coords.altitude,
            altitudeAccuracy: position.coords.altitudeAccuracy,
            accuracy: position.coords.accuracy,
          })
        },
        (e) => {
          console.warn("getCurrentPosition error", e)
          setWarning(e.message)
          resolve(null)
          //reject(e.message)
        },
        { timeout: 30000, ...options }, // the default is no timeout, which would leave the overlay up for good
      )
    }
  }).finally(() => stopLoading("getLocationAsync"))
}

provide("getLocationAsync", getLocationAsync)
provide("hasLocationPermissions", "geolocation" in window.navigator)
</script>

<style scoped>
/* open/close animation without Bootstrap's Collapse JS: the grid row grows from 0fr to its content height */
@media (max-width: 991.98px) {
  .navbar-collapse {
    display: grid;
    grid-template-rows: 0fr;
    overflow: hidden;
    transition: grid-template-rows 0.2s ease;
  }
  .navbar-collapse.show {
    grid-template-rows: 1fr;
  }
  /* a margin would leak through the closed 0fr row (mb-2), so the spacing is padding here */
  .navbar-collapse > .navbar-nav {
    min-height: 0;
    margin-bottom: 0 !important;
    padding-bottom: 0.5rem;
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .navbar-collapse {
    transition: none;
  }
}
</style>
